import clsx from "clsx";
import React from "react";
import * as styles from "web/react/components/feeds-filters/feed-filter-categories/feed-filter-categories.css";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import { UniversalFilterOptionSerializer } from "web/types/serializers";
import { UniversalFilterOption } from "web/types/universal-filters";

export interface CategoryBreadcrumbsProps {
    options: any[];
    onClick: (filter: UniversalFilterOption | UniversalFilterOptionSerializer) => void;
}

export function CategoryBreadcrumbs({
    options,
    onClick,
}: CategoryBreadcrumbsProps): JSX.Element | null {
    const breadcrumbs = options
        .map((crumbList) => {
            return crumbList.options.filter((crumb) => {
                return crumb.children.length > 0 && crumb.checked;
            });
        })
        .flat();

    const hasBreadcrumbs = breadcrumbs.length > 0;

    return (
        <div className={styles.breadcrumbContainer}>
            <>
                {hasBreadcrumbs && <SVGIcon className={styles.smallArrow} name={"small-arrow"} />}
                <button onClick={() => breadcrumbs.length > 0 && onClick(breadcrumbs[0])}>
                    <Text
                        className={clsx({ [styles.allCategoriesLink]: hasBreadcrumbs })}
                        key={"all_categories"}
                        textStyle={"small-link"}
                    >
                        {
                            // "All Categories"
                            gettext("feed.filters.category.all_categories")
                        }
                    </Text>
                </button>
                {hasBreadcrumbs && (
                    <Text className={styles.divider} textStyle={"small-link"}>
                        {">"}
                    </Text>
                )}
            </>
            {breadcrumbs.map((crumb, index) => {
                return breadcrumbs.length > index + 1 ? (
                    <div key={crumb.id}>
                        <button
                            onClick={() => {
                                if (breadcrumbs.length > index + 1) {
                                    onClick(breadcrumbs[index + 1]);
                                }
                            }}
                        >
                            <Text className={styles.breadcrumbLink} textStyle={"small-link"}>
                                {crumb.label}
                            </Text>
                        </button>
                        <Text className={styles.divider} textStyle={"small-link"}>
                            {">"}
                        </Text>
                    </div>
                ) : (
                    <Text key={crumb.id} className={styles.breadcrumb} textStyle={"small-link"}>
                        {crumb.label}
                    </Text>
                );
            })}
        </div>
    );
}
